import { createSelector } from 'reselect';
import { getInsurances } from './getInsurances';

export const getHasInsurances = createSelector([getInsurances], (insurances) => {
  return insurances.length > 0;
});
